var __jsx = React.createElement;
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { trackReferralClick } from '@spa/offer/store/actions/tracking';
import { Heading, Container, Rows, Description, ValueProposition } from './styles';
import { valuePropositionItems } from '@spa/shared/constants/valuePropositionItems';
var WhyRentWithUniplaces = function WhyRentWithUniplaces(_ref) {
  var trackReferralClickAction = _ref.trackReferralClickAction;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return __jsx(Container, null, __jsx(Heading, null, t('Why rent with Uniplaces')), __jsx(ValueProposition, null, valuePropositionItems.map(function (_ref2) {
    var title = _ref2.title,
      description = _ref2.description;
    return __jsx(Rows, {
      key: t(title)
    }, __jsx(Description, null, __jsx("h3", null, t(title)), __jsx("p", null, t(description))));
  })));
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackReferralClickAction: function trackReferralClickAction() {
      return dispatch(trackReferralClick({
        context: 'why-rent-with-uniplaces'
      }));
    }
  };
};
export default connect(null, mapDispatchToProps)(WhyRentWithUniplaces);